module.exports = __webpack_public_path__ + "img/smaller-send-arrow.252219a5.svg";